var setWidthEqualToTarget = function(target, el) {
    setTimeout(function() {
        var width = jQuery(target).outerWidth();
        jQuery(el).width(width);
    }, 300);
}

export {
    setWidthEqualToTarget
};